




import { Component, Provide, Vue } from 'vue-property-decorator';

type TItem = {
  text: string;
  to?: string;
  exact?: boolean;
};

@Component
export default class ElementBreadcrumbs extends Vue {
  @Provide() items: TItem[] = [];

  created() {
    this.$pdc.bus!.on('app:navbar:breadcrumbs', this.updateBreadcrumbs);
  }

  beforeDestroy() {
    this.$pdc.bus!.off('app:navbar:breadcrumbs', this.updateBreadcrumbs);
  }

  updateBreadcrumbs(items: TItem[]) {
    this.items = items.map((x) => ({
      ...x,
      text: this.$options.filters!.capitalize(x.text),
    }));
  }
}
